
import React from "react";
import { motion } from "framer-motion";
import { Users, BriefcaseBusiness, Group } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const InfoCards: React.FC = () => {
  const cards = [
    {
      title: "Complementary Skills",
      description: "Build a team with diverse and complementary skills to tackle complex projects efficiently.",
      icon: <Users className="h-10 w-10 text-indigo-500" />
    },
    {
      title: "Specialized Expertise",
      description: "Access specialized talent for each aspect of your project, ensuring quality at every stage.",
      icon: <BriefcaseBusiness className="h-10 w-10 text-indigo-500" />
    },
    {
      title: "Collaborative Success",
      description: "Foster collaboration between team members who have experience working together on similar projects.",
      icon: <Group className="h-10 w-10 text-indigo-500" />
    }
  ];

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3, duration: 0.5 }}
      className="mt-12"
    >
      <h2 className="text-2xl font-bold mb-6">Why Build a Team?</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {cards.map((card, index) => (
          <Card key={index} className="border-t-4 border-t-indigo-500">
            <CardHeader>
              <div className="mb-2">{card.icon}</div>
              <CardTitle>{card.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">{card.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </motion.div>
  );
};
